<template>
  <i-page class="login">
    <div class="wrapper">
      <p-logo class="logo" />
      <div class="companyDetails" v-if="companyDetails">
        <img :src="'data:image/png;base64,' + companyDetails.AppLogo" />
        <h1 dir="ltr">{{ companyDetails.CustomerName }}</h1>
      </div>
      <router-view />
    </div>
    <p-footer />
  </i-page>
</template>

<script>
import { mapState } from "vuex";
import { getCompanyDetails, apiGetCompGuidByBID } from "@/services/APointAPI";
import PLogo from "@/components/partials/p-logo";
import PFooter from "@/components/partials/p-footer";

export default {
  components: {
    PLogo,
    PFooter,
  },
  data() {
    return {
      companyDetails: null,
    };
  },
  computed: {
    ...mapState({
      compGUID: (state) => state.api.compGUID,
      compID: (state) => state.api.compID,
      bID: (state) => state.api.bID,
      companiesCount: (state) => state.api.companiesCount,
    }),
  },
  watch: {
    compGUID() {
      if (this.companiesCount == 1 || this.companiesCount === 0)
        this.GetCompanyDetails();
      else this.companyDetails = null;
    },
  },
  mounted() {
    if (this.companiesCount == 1 || this.companiesCount === 0)
      if (this.compGUID) this.GetCompanyDetails();
      else if (this.compID && this.bID) this.GetCompGuidByBID();
  },
  methods: {
    GetCompGuidByBID() {
      apiGetCompGuidByBID(this.compID, this.bID).then((result) => {
        result = JSON.parse(result);
        this.$store.commit("api/setSessionData", {
          compGUID: result.Table[0].CompGUID,
          webPswd: result.Table[0].webPswd,
        });
        this.GetCompanyDetails();
      });
    },
    GetCompanyDetails() {
      getCompanyDetails().then((result) => {
        if (result) {
          result = JSON.parse(result);
          this.companyDetails = result;          
        }
      });
    },
  },
};
</script>

<style scoped>
.login {
  display: flex;
  flex-direction: column;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-image: url("../assets/img/banners/login-bg.jpg");
}

/* .logo {
  margin-bottom: 35px;
} */

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.companyDetails {
  padding-top: 30px;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.companyDetails img {
  width: 100px;
}
.companyDetails h1 {
  margin: 10px 0;
}
/* @media screen and (min-height: 700px) {
  .wrapper {
    padding-top: 20vh;
  }
}

@media screen and (min-height: 1000px) {
  .wrapper {
    padding-top: 23vh;
  }
} */
</style>
